module.exports = __webpack_public_path__ + "img/save.9f2a4483.jpg";